export default __webpack_public_path__ + "static/setup-config-match-datatag-c26949a9848d5b42dbc789965d1d586f.mp4";